<template>
  <div class="page" id="product_package_start">
    <!-- <a
      @click.prevent="viewAllExp"
      href
      class="text-blue button link mt-0 mb-0 text-center"
    >View all experiences</a>-->
    <product-image v-if="activeProductDetails.PhotoVersion" />

    <section class="container">
      <product-name
        :DisplayPrice="activeProductDetails.DisplayPrice"
        :DisplayDiscount="activeProductDetails.DisplayDiscount"
        :productName="activeProductDetails.Name"
        :clientName="client.Name"
        :privateToursOnly="privateToursOnly"
        :OverrideAutoPrice="activeProductDetails.OverrideAutoPrice"
        :Savings="activeProductDetails.Savings"
      />

      <div v-if="!privatePackage">
        <hgroup class="flex pt-1">
          <div class>
            <h3>Guests</h3>
            <p>
              How many
              {{ activeProductDetails.RateLabelPlural ? activeProductDetails.RateLabelPlural : "guests" }}
              are in this package?
            </p>
            <pre>				activeProductDetails.MaxParticipants: {{ activeProductDetails.MaxParticipants }}</pre>
            <pre>				activeProductDetails.MinParticipants: {{ activeProductDetails.MinParticipants }}</pre>
            <pre>				activeProductDetails.MaxPeople: {{ activeProductDetails.MaxPeople }}</pre>
            <pre>				activeProductDetails.Participants: {{ activeProductDetails.Participants }}</pre>
          </div>
        </hgroup>
        <number-ticker
          v-model="activeProductDetails.Participants"
          :disableAdd="activeProductDetails.Participants >= myMax"
          :max="myMax"
          :min="myMin"
        />
        <p
          v-if="activeProductDetails.MinParticipants && activeProductDetails.MinParticipants > 1"
          :class="{
            'text-red shake-animation': activeProductDetails.Participants > 0 && activeProductDetails.Participants < myMin,
          }"
        >
          <small
            >This package requires at least
            {{ activeProductDetails.MinParticipants }}
            {{ activeProductDetails.MinParticipants == 1 ? "participant" : "participants" }}.</small
          >
        </p>
      </div>

      <br />

      <!--      <pre>NOTE: There are no private tours with packages.</pre>-->
      <!--      <pre>NOTE: There are no pickup locations with packages.</pre>-->

      <!--      <pre>packageIsGettingTimes: {{ packageIsGettingTimes }}</pre>-->

      <!--      <div v-for="act in activeProductDetails.Activities">-->
      <!--        <pre v-if="act.getTimesLoading">-->
      <!--act.getTimesLoading: {{ act.getTimesLoading }}</pre-->
      <!--        >-->
      <!--        <pre v-else="">act.getTimesLoading: false -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</pre>-->
      <!--      </div>-->

      <div class="mb-3">
        <package-activity-card
          v-show="privatePackage || (activeProductDetails.Participants && activeProductDetails.Participants >= myMin)"
          v-for="(activity, i) in activeProductDetails.Activities"
          :activity="activity"
          :activity_index="i"
          :totalGuestInPackage="activeProductDetails.Participants"
          :activities_count="activeProductDetails.Activities.length"
          :key="'package-details-activity-card-' + activity.EntityHierarchyKey + '-' + i"
          :isPackage="activeProductDetails.PackageKey"
          :addToCartLoading="addToCartLoading"
          :activeProductDetails="activeProductDetails"
          :privatePkg="privatePackage"
        />
      </div>
      <div class="_silver_border_top pb-2 pt-0">
        <h3>Overview</h3>

        <div v-html="activeProductDetails.Description"></div>
      </div>
      <div class="silver_border_top pb-3">
        <location-map :client="client" />
      </div>

      <!-- <powered-by /> -->
    </section>

    <page-header :cleverBack="true" @cleverBackToList="cleverBackToList" :fixed="true">
      <a @click.prevent="viewAllExp" href class="text-blue button link mt-0 mb-0 text-center pt-1 pb-1 text-right size-med">View all experiences</a>
      <cart-icon slot="cart_bar" />
    </page-header>

    <page-footer>
      <template v-slot:text>
        <h4>{{ activeProductDetails.Participants }} guest{{ activeProductDetails.Participants > 1 ? "s" : "" }}</h4>
        <small v-if="addToCartEnabled || !activeProductDetails.HideRateDiscountFromCustomer">
          Subtotal:
          <product-sub-total />
          <span v-if="packageSavings"
            ><br />Package savings:
            <currency :value="packageSavings" />
          </span>
        </small>
      </template>
      <template v-slot:button>
        <button
          :disabled="addToCartLoading || !addToCartEnabled || packageIsGettingTimes"
          @click.prevent="addToCart()"
          href="#"
          :class="{
            button_loading: addToCartLoading,
            'scale-animation': addToCartEnabled,
          }"
          class="button blue ml-1 text-center"
        >
          {{ $route.params.modify == "modify" ? "Save&nbsp;changes" : "Add&nbsp;to&nbsp;cart" }}
        </button>
      </template>
    </page-footer>

    <!-- <page-footer></page-footer> -->

    <post-add-to-cart-modals
      :addToCartLoading="addToCartLoading"
      :modelErrorsModal="modelErrorsModal"
      @modelErrorsModalOk="modelErrorsModalOk"
      :takenTimesModal="takenTimesModal"
      @takenTimesModalOk="takenTimesModalOk"
      :overlappedActivitiesModal="overlappedActivitiesModal"
      @overlappedActivitiesModalNo="overlappedActivitiesModalNo"
      @overlappedActivitiesModalYes="overlappedActivitiesModalYes"
      :isPackage="activeProductDetails.PackageKey"
    />
  </div>
</template>

<script>
// mixins
import analyticsMixin from "../../mixins/analyticsMixin.js";
import addToCart from "../../mixins/addToCart.js";
import PostAddToCartModals from "../../components/PostAddToCartModals.vue";

import CartIcon from "../../components/CartIcon.vue";
import ProductSubTotal from "../../components/ProductSubTotal.vue";
import PageFooter from "../../components/PageFooter.vue";
import ProductImage from "../../components/ProductImage.vue";
import ProductName from "../../components/ProductName.vue";
import NumberTicker from "../../components/NumberTicker.vue";
import PackageActivityCard from "../../components/PackageActivityCard.vue";
import LocationMap from "../../components/LocationMap.vue";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "PackageDetailsStart",
  //props: ["details"],
  data: function() {
    return {
      scrollTop: 0,
      //addToCartLoading: false //  moved to mixin
    };
  },

  activated() {
    let el = document.querySelector("#package_details");
    el.scrollTop = this.scrollTop;
  },

  beforeRouteLeave: function(to, from, next) {
    let pathmatch = /\/\d*\/activity$/;
    if (pathmatch.test(to.path) && window.parent) {
      window.parent.postMessage({ detail_leave: true }, "*");
    }

    let el = document.querySelector("#package_details");
    this.scrollTop = el.scrollTop;
    next();
  },
  mounted() {
    console.log("created", this.privatePackage);
    if (this.privatePackage) this.activeProductDetails.Participants = this.myMax;
  },

  mixins: [addToCart, analyticsMixin],

  computed: {
    ...mapState(["client"]),
    ...mapGetters(["activeProductDetails"]),
    privatePackage() {
      return this.activeProductDetails.Activities.every((act) => act.PrivateToursOnly == true);
    },
    packageIsGettingTimes() {
      let f = !!this.activeProductDetails.Activities.find((ele) => {
        return ele.getTimesLoading === true;
      });
      //console.log("f: " + f);
      return f;
    },

    packageSavings() {
      let total = 0;
      this.activeProductDetails.Activities.forEach((act) => {
        //console.log("**** act", act.Name);
        //console.log("**** total", total);
        act.Rates.forEach((rate) => {
          //console.log("************ rate", rate.Name);
          total = total + rate.Participants * rate.PackageDiscount;
          // console.log(
          //   "************ adding",
          //   rate.Participants * rate.PackageDiscount
          // );
          //console.log("************ total", total);
        });
      });
      return total;
    },

    privateToursOnly() {
      let r = false;
      if (this.activeProductDetails && this.activeProductDetails.Activities) {
        this.activeProductDetails.Activities.forEach((act) => {
          if (act.PrivateToursOnly) {
            r = true;
          }
        });
      }
      return r;
    },

    myMax() {
      return this.activeProductDetails.MaxParticipants ? this.activeProductDetails.MaxParticipants : 99999999;
    },
    myMin() {
      return this.activeProductDetails.MinParticipants ? this.activeProductDetails.MinParticipants : 0;
    },

    addToCartEnabled() {
      //
      var $return = true;
      if (this.activeProductDetails.Participants < this.activeProductDetails.MinParticipants) {
        $return = false;
      }

      this.activeProductDetails.Activities.forEach((act) => {
        // do all activities have participants
        var totalParticipantsInActivity = 0;

        // if CapacityTypeKey == 2, we are concerned with act SelectedTimes[],
        // otherwise, we are concerned with Rates[]
        if (act.CapacityTypeKey == 2 || act.CapacityTypeKey == 3) {
          var selectedTimesParticipants = 0;

          // make sure each selected times total,
          // matches the grand total of the whoel package
          if (act.SelectedTimes) {
            act.SelectedTimes.forEach((selectedTime) => {
              selectedTime.Rates.forEach((rate) => {
                selectedTimesParticipants = selectedTimesParticipants + rate.Participants;
              });
            });

            if (this.activeProductDetails.Participants != selectedTimesParticipants) {
              $return = false;
            }
          }
        }
        // CapacityTypeKey != 2 && CapacityTypeKey != 3
        else {
          if (act.Rates) {
            act.Rates.forEach((rate) => {
              if (!rate.IsPrivateTourRate) {
                totalParticipantsInActivity = totalParticipantsInActivity + rate.Participants;
              }
            });
          }

          // if private pkg tour # guests done matter in activity as long as its != 0
          if (act.IsPrivateTour) {
            $return = totalParticipantsInActivity != 0;
          } else if (totalParticipantsInActivity != this.activeProductDetails.Participants) {
            $return = false;
          }
        }

        if (act.SelectedTimes && !act.SelectedTimes.length) {
          $return = false;
        }

        if (!act.AppointmentDate) {
          $return = false;
        }
      });
      return $return;
    },

    // modifiedActiveProductDetails() {
    //   // make a unique copy
    //   var copy = JSON.parse(JSON.stringify(this.activeProductDetails));

    //   var orderKey = this.$store.state.order.OrderKey
    //     ? this.$store.state.order.OrderKey
    //     : null;

    //   copy.OrderKey = orderKey;

    //   copy.Activities.forEach(act => {
    //     act.OrderKey = orderKey;
    //     act.ConfirmationMessage = null;
    //     act.Description = null;
    //     act.GroupEmailFooter = null;
    //     act.NoAvailabilityMessage = null;

    //     act.AppointmentDate = this.$moment(act.AppointmentDate).format(
    //       "YYYY-MM-DD"
    //     );
    //   });

    //   return copy;
    // }
  },
  methods: {
    ...mapActions(["ajaxAddToCart", "viewAllExp"]),

    cleverBackToList() {
      this.$emit("cleverBackToList", {});
    },

    // addToCart() {
    //   this.addToCartLoading = true;

    //   this.$emit("updateConfirmLeave", true);

    //   this.ajaxAddToCart(this.modifiedActiveProductDetails).then(
    //     // eslint-disable-next-line no-unused-vars
    //     json => {
    //       this.addToCartLoading = false;
    //       // console.log(
    //       //   "Got some data, now lets show something in this component"
    //       // );
    //     },
    //     // eslint-disable-next-line no-unused-vars
    //     err => {
    //       this.addToCartLoading = false;

    //       this.$emit("updateConfirmLeave", false);

    //       // console.error(
    //       //   "Got nothing from server. Prompt user to check internet connection and try again"
    //       // );
    //     }
    //   );
    // }
  },
  components: {
    ProductImage,
    ProductName,
    NumberTicker,
    PackageActivityCard,
    PageFooter,
    ProductSubTotal,
    CartIcon,
    LocationMap,
    PostAddToCartModals,
  },
};
</script>

<style></style>
